import React, { Component } from 'react';
import { connect } from 'react-redux';
import numeral from 'numeral';
import './InvoiceDetails.css';
import {
  getCurrentInvoice,
  getCustomEmail,
  getCustomEmailValid,
  getEdit,
  getForm,
  getInvoices,
  getPdf,
  getShowEmailModal,
  getShowPdfViewer,
  getShowSave,
  getUsersByClientId,
  getUsersIdSelected,
} from 'selectors/admin/invoices/invoices';
import {
  cancelEdit,
  closePdfViewer,
  customEmailAdd,
  customEmailChange,
  emailRemove,
  invalid,
  loadInvoiceRequest,
  loadUsersRequest,
  markAsPaidRequest,
  printInvoice,
  sendEmail,
  sendInvoiceRequest,
  setEdit,
  setShowEmailModal,
  updateFormAttributeChange,
  updateInvoiceRequest,
  userSelected,
  usersEmailAdd,
  valid,
} from 'actions/admin/invoices/invoices';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import { getCurrentUser } from 'selectors/authentication';
import { ROLES, TYPES, usersUtil } from 'services/utils/users-util';
import checkSquarePng from 'images/check-square.png';
import Button from 'components/shared/button/Button';
import InvoiceData from 'components/admin/invoices/InvoiceData';
import mailWhiteSvg from 'images/mail-white.svg';
import printWhiteSvg from 'images/print-white.svg';
import PdfViewer from 'components/shared/pdf-viewer/PdfViewer';
import { EmailModal } from 'components/shared/email/EmailModal';
import { WorkOrder } from 'domain/work-order';
import TotalTables from 'components/admin/invoices/TotalTables';
import { simpleScrollToTop } from 'services/utils/scroller-util';

class InvoiceDetails extends Component {
  constructor(props) {
    super(props);

    // Keep track of id to avoid showing an "old" invoice while loading the current one
    this.invoiceId = numeral(this.props.match.params.id).value();
    this.isClient = usersUtil.hasType(this.props.currentUser, TYPES.CLIENT);
  }

  render() {
    if (
      this.props.currentInvoice !== null &&
      this.props.currentInvoice.id === this.invoiceId
    ) {
      const isPaid = this.props.currentInvoice.status === 'paid';
      const isSent = this.props.currentInvoice.sent_at !== null;
      const isSpackleAdmin =
        usersUtil.hasRole(this.props.currentUser, ROLES.SPACKLE_ADMIN) ||
        usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR);

      let clientUsers = [];
      if (
        this.props.usersByClientId[this.props.currentInvoice.client.id] !==
        undefined
      ) {
        clientUsers = this.props.usersByClientId[
          this.props.currentInvoice.client.id
        ];
      }

      return (
        <div className="invoice-details">
          <RouteTitle
            titles={[
              'INVOICES',
              `INVOICE WO #${this.props.currentInvoice.work_order.number}`,
            ]}
          />

          <div className="full-title">
            <span>
              Invoice (WO {this.props.currentInvoice.work_order.number})
            </span>
            {this.isClient && (
              <div className="print-email-buttons">
                <Button
                  className="button-gray"
                  icon={mailWhiteSvg}
                  label="Email"
                  onClick={this.handleEmail}
                />
                <Button
                  className="button-gray"
                  icon={printWhiteSvg}
                  label="Print"
                  onClick={this.handlePrint}
                />
              </div>
            )}
          </div>

          <div className="content-container">
            <div className="invoice-data-container">
              <InvoiceData
                to={this.props.currentInvoice.client.company_name}
                completionDate={this.props.currentInvoice.completion_date}
                customEmail={this.props.customEmail}
                customEmailValid={this.props.customEmailValid}
                dueDate={this.props.form.dueDate}
                cost={this.props.currentInvoice.total_cost}
                edit={this.props.edit}
                emails={this.props.form.emails}
                purchaseOrder={
                  this.props.currentInvoice.work_order.purchase_order
                }
                showSendTo={isSpackleAdmin}
                users={
                  this.props.usersByClientId[
                    this.props.currentInvoice.client.id
                  ] !== undefined
                    ? this.props.usersByClientId[
                        this.props.currentInvoice.client.id
                      ]
                        .filter(
                          (user) =>
                            this.props.form.emails.find(
                              (userEmail) => userEmail.email === user.email
                            ) === undefined
                        )
                        .map((user) => {
                          return {
                            id: user.id,
                            email: user.email,
                            name: `${user.first_name} ${user.last_name}`,
                            selected:
                              this.props.usersIdSelected.find(
                                (id) => id === user.id
                              ) !== undefined,
                          };
                        })
                    : []
                }
                onAttributeChange={this.handleFormAttributeChange}
                onEmailRemove={this.handleEmailRemove}
                onCustomEmailAdd={this.handleCustomEmailAdd}
                onCustomEmailChange={this.handleCustomEmailChange}
                onUsersAdd={this.handleUsersAdd}
                onUserSelected={this.handleUserSelected}
              />

              <div className="inv-buttons-container">
                {isSpackleAdmin && !isPaid && !this.props.edit && (
                  <Button
                    label="Mark as Paid"
                    className="button-orange"
                    onClick={this.handleMarkAsPaid}
                  />
                )}
                {isPaid && (
                  <div className="not-paid-indicator">
                    <img src={checkSquarePng} alt="yes" />
                    <div className="button button-white-orange">
                      <span>Paid</span>
                    </div>
                  </div>
                )}
                {isSpackleAdmin && !isPaid && !this.props.edit && (
                  <React.Fragment>
                    <Button
                      label={isSent ? 'Send Again' : 'Send'}
                      className="button-blue-grey"
                      onClick={this.handleSend}
                    />
                    <Button
                      label="Edit"
                      className="button-gray"
                      onClick={this.handleEdit}
                    />
                  </React.Fragment>
                )}
              </div>
            </div>

            <TotalTables />

            {isSpackleAdmin && this.props.edit && (
              <div className="extra-save-cancel-buttons">
                <div>
                  <Button
                    label="Save"
                    className="button-gray"
                    onClick={this.handleUpdate}
                  />
                  <Button
                    label="Cancel"
                    className="button-white"
                    onClick={this.handleCancel}
                  />
                </div>
              </div>
            )}

            <hr />

            <div className="payment-container">
              <div className="payment-info">
                <div>Send Payment to:</div>
                <div>Spackle, Inc.</div>
                <div>4130 Cahuenga Blvd, Suite 206</div>
                <div>Los Angeles, CA 91602</div>
              </div>

              <div className="payment-info">
                <span>
                  <strong><u>Please note</u></strong>, our banking has changed. To pay via ACH please contact us at{' '}
                  <a href={'mailto:accounts@spackle.co'} className="mailto">
                    accounts@spackle.co
                  </a>.
                </span>
              </div>
            </div>
          </div>

          <PdfViewer
            content={{
              source: this.props.pdf,
              type: 'blob',
            }}
            show={this.props.showPdfViewer}
            onClose={this.handlePdfViewerClose}
          />

          <EmailModal
            defaultEmails={clientUsers
              .filter((user) => user.account_creator)
              .map((user) => user.email)}
            defaultMessage={this.getEmailMessage()}
            defaultSubject={this.getEmailSubject()}
            emails={clientUsers.map((user) => user.email)}
            title={this.getEmailTitle()}
            show={this.props.showEmailModal}
            onClose={this.handleEmailModalClose}
            onSend={this.handleEmailSend}
          />
        </div>
      );
    } else {
      return null;
    }
  }

  componentDidMount() {
    if (
      this.props.currentInvoice === null ||
      this.props.currentInvoice.id !== this.invoiceId
    ) {
      this.props
        .dispatch(loadInvoiceRequest(this.invoiceId))
        .then((response) => {
          if (response.ok) {
            if (
              this.props.usersByClientId[response.invoice.client.id] ===
              undefined
            ) {
              this.props.dispatch(loadUsersRequest(response.invoice.client.id));
            }
          }
        });
    }
  }

  getEmailMessage = () => {
    let location = '';
    if (this.props.currentInvoice.building !== null) {
      const building = this.props.currentInvoice.building;
      location = ` at ${building.location.street_address_1}, ${building.location.city} ${building.location.state}`;
    }

    return `Please find the attached invoice for WO #${this.props.currentInvoice.work_order.number}${location}. \
If you have any questions, please reach out via chat or email.

Thank you`;
  };

  getEmailSubject = () => {
    let name = '';
    if (WorkOrder.getName(this.props.currentInvoice.work_order) !== null) {
      name = ` - ${WorkOrder.getName(this.props.currentInvoice.work_order)}`;
    }
    return `Spackle Invoice for WO #${this.props.currentInvoice.work_order.number}${name}`;
  };

  getEmailTitle = () => {
    return `Invoice for WO #${this.props.currentInvoice.work_order.number}`;
  };

  handleCancel = () => {
    simpleScrollToTop();
    this.props.dispatch(cancelEdit(this.props.currentInvoice));
  };

  handleCustomEmailAdd = () => {
    this.props.dispatch(customEmailAdd(this.props.customEmail));
  };

  handleCustomEmailChange = (value) => {
    this.props.dispatch(customEmailChange(value));
  };

  handleEdit = () => {
    this.props.dispatch(setEdit(true));
  };

  handleEmail = () => {
    this.props.dispatch(setShowEmailModal(true));
  };

  handleEmailModalClose = () => {
    this.props.dispatch(setShowEmailModal(false));
  };

  handleEmailRemove = (id, index) => {
    this.props.dispatch(emailRemove(id, index));
  };

  handleEmailSend = (emails, subject, message) => {
    this.props.dispatch(
      sendEmail(this.props.currentInvoice.id, emails, subject, message)
    );
  };

  handleFormAttributeChange = (attribute, value) => {
    this.props.dispatch(updateFormAttributeChange(attribute, value));
  };

  handleMarkAsPaid = () => {
    this.props.dispatch(markAsPaidRequest(this.props.currentInvoice.id));
  };

  handlePdfViewerClose = () => {
    this.props.dispatch(closePdfViewer());
  };

  handlePrint = () => {
    this.props.dispatch(printInvoice(this.invoiceId));
  };

  handleSend = () => {
    this.props.dispatch(sendInvoiceRequest(this.props.currentInvoice.id));
  };

  handleUpdate = () => {
    const invalidLineItemId = Object.keys(
      this.props.form.amountsByLineItemId
    ).filter((key) => this.props.form.amountsByLineItemId[key] === '');
    if (invalidLineItemId.length > 0) {
      this.props.dispatch(
        invalid(invalidLineItemId, 'The outlined costs are required.')
      );
    } else {
      this.props.dispatch(valid());
      this.props.dispatch(
        updateInvoiceRequest(
          this.props.currentInvoice.id,
          this.props.form,
          this.props.currentInvoice.misc_items
        )
      );
    }
  };

  handleUsersAdd = () => {
    this.props.dispatch(
      usersEmailAdd(
        this.props.usersIdSelected,
        this.props.usersByClientId[this.props.currentInvoice.client.id]
      )
    );
  };

  handleUserSelected = (userId) => {
    this.props.dispatch(userSelected(userId, this.props.usersIdSelected));
  };
}

export default connect((state) => {
  return {
    currentInvoice: getCurrentInvoice(state),
    currentUser: getCurrentUser(state),
    customEmail: getCustomEmail(state),
    customEmailValid: getCustomEmailValid(state),
    edit: getEdit(state),
    form: getForm(state),
    // invalidFields: getInvalidFields(state),
    invoices: getInvoices(state),
    pdf: getPdf(state),
    showEmailModal: getShowEmailModal(state),
    showPdfViewer: getShowPdfViewer(state),
    showSave: getShowSave(state),
    usersByClientId: getUsersByClientId(state),
    usersIdSelected: getUsersIdSelected(state),
    // validationMessage: getValidationMessage(state)
  };
})(InvoiceDetails);



// WEBPACK FOOTER //
// ./src/components/admin/invoices/InvoiceDetails.js